export default "__VITE_ASSET__BrR5PQ6v__ 100w";